import { initializeApp } from "firebase/app";
import {
	type PopupRedirectResolver,
	browserLocalPersistence,
	browserPopupRedirectResolver,
	initializeAuth,
} from "firebase/auth";
import { config } from "../config";

if (!config.firebase) {
	throw new Error("Firebase configuration is missing");
}

export const app = initializeApp(config.firebase);

const popupRedirectResolver =
	config.auth?.strategy === "adfs" ? (browserPopupRedirectResolver as PopupRedirectResolver) : undefined;

export const auth = initializeAuth(app, {
	persistence: browserLocalPersistence,
	popupRedirectResolver,
});
